"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCanvasRepository = exports.AdapterClasses = void 0;
var _Canvas = require("./Canvas");
var AdapterClasses = exports.AdapterClasses = {
  Canvas: _Canvas.Canvas
};
var createCanvasRepository = exports.createCanvasRepository = function createCanvasRepository() {
  var repositoryMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Map();
  var activeCanvas;
  var requestCanvas = function requestCanvas(key) {
    var canvasSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$updateCanvas = options.updateCanvas,
      updateCanvas = _options$updateCanvas === void 0 ? false : _options$updateCanvas;
    if (!repositoryMap.has(key) || updateCanvas) {
      var _canvas = new AdapterClasses.Canvas();
      _canvas.init(); // create canvas element
      if (canvasSize) {
        _canvas.setSize(canvasSize);
      }
      repositoryMap.set(key, _canvas);
      if (repository.onCreate) {
        repository.onCreate(_canvas);
      }
    }
    var canvas = repositoryMap.get(key);
    var _options$activate = options.activate,
      activate = _options$activate === void 0 ? true : _options$activate;
    if (activate) {
      canvas.activate();
      // clear selection if the active canvas is not the same as the previous one
      if (activeCanvas && activeCanvas !== canvas) {
        activeCanvas.clearSelection();
      }
      activeCanvas = canvas;
    }
    return canvas;
  };
  var getActiveCanvas = function getActiveCanvas() {
    return activeCanvas;
  };
  var repository = {
    requestCanvas: requestCanvas,
    getActiveCanvas: getActiveCanvas
  };
  return repository;
};